// Display constants for the Rewards (referral payout) page; the requests themselves
// come from GET /api/admin/referrals (see useWithdrawalRequests)

export const REWARD_STATUS = {
  requested: { label: "Requested", tone: "warning" },
  paid: { label: "Paid", tone: "success" },
  rejected: { label: "Rejected", tone: "danger" },
};

export const REJECTION_REASONS = ["Withdrawal count error", "Incorrect address", "Duplicate request"];

export const REWARD_NETWORK = "Ethereum (ERC-20)";

// Total earned = lifetime credited, pending = still in the 14-day hold, available = matured and unclaimed
export const REWARD_STAT_LABELS = [
  { key: "totalEarned", label: "Total earned" },
  { key: "pending", label: "Pending" },
  { key: "available", label: "Available" },
];
